(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('EventsRunner', EventsRunner);

    function EventsRunner($q, lodash, ActionManager) {
        return function(events, trigger, inputData) {
            return $q.when(eventsRunnerFunc(trigger, inputData));

            function eventsRunnerFunc(_trigger, data) {
                const event = lodash.find(events, {event: _trigger});
                // usually only 1 event to run.

                if (event) {
                    return $q.when(handleEventRunner(event, data));
                }
                return data;
            }

            function handleEventRunner(event, data) {
                const asyncActions = lodash.get(event, 'actions.async', []);
                const syncActions = lodash.get(event, 'actions.sync', []);
                for (const asyncAction of asyncActions) {
                    ActionManager(
                        asyncAction.name, // required
                        lodash.get(asyncAction, 'options', {}),
                        data
                    );
                }

                if (syncActions.length > 0) {
                    return handleEventSyncActions(syncActions, 0, data).then(function(res) {
                        const lastAction = lodash.last(syncActions);
                        return eventsRunnerFunc([event.event, lastAction.name, res.actionType].join('.'), res.response);
                    });
                } else {
                    const eventLastName = lodash.last(event.event.split('.'));
                    return !(['error', '422'].indexOf(eventLastName) >= 0);
                }
            }

            function handleEventSyncActions(actions, currentIndex, data) {
                if (currentIndex >= actions.length) {
                    return data;
                }
                const currentAction = actions[currentIndex];
                return $q.when(ActionManager(
                    currentAction.name,
                    lodash.get(currentAction, 'options', {}),
                    data
                )).then(function(resp) {
                    return {
                        actionType: 'success',
                        response: handleEventSyncActions(actions, currentIndex+1, resp)
                    };
                }, function(err) {
                    return {
                        actionType: (err.status === 422) ? 422 : 'error',
                        response: (err.status === 422) ? err : false
                    };
                });
            }
        };


    }
})();